import { StyleSheet, UnistylesRuntime } from "react-native-unistyles";

const stylesheet = StyleSheet.create(
  ({ spacing, colors, border }, { insets }) => ({
    container: {
      paddingBottom: insets.bottom + spacing(12),
    },
    imageContainer: {
      position: "absolute",
      width: "100%",
      height: {
        xs: spacing(96),
        lg: spacing(200),
      },
    },
    content: {
      gap: spacing(8),
      marginHorizontal: "auto",
      marginRight: {
        xs: spacing(0),
        lg: spacing(46),
      },
      marginLeft: {
        xs: spacing(0),
        lg: spacing(46),
      },
      paddingTop: {
        xs: spacing(21),
        lg: spacing(42),
      },
    },
    meta: {
      flexDirection: "row",
      gap: {
        xs: spacing(4),
        lg: spacing(6),
      },
      paddingTop: {
        xs: spacing(72),
        lg: spacing(96),
      },
    },
    metaPoster: {
      aspectRatio: 3 / 4,
      borderRadius: border.radius.md,
      alignSelf: "center",
      backgroundColor: colors.backgroundFloat,
      height: {
        xs: spacing(28),
        md: spacing(48),
      },
    },
    metaDetails: {
      flexBasis: 0,
      flexGrow: 1,
      flexShrink: 1,
      maxWidth: spacing(224),
      justifyContent: "center",
      gap: spacing(1),
    },
    actions: {
      flexDirection: {
        xs: "column",
        md: "row",
      },
      flexWrap: {
        xs: "nowrap",
        md: "wrap",
      },
      gap: spacing(4),
    },
    episodes: {
      width: "100%",
      marginHorizontal: "auto",
      marginRight: {
        xs: spacing(0),
        lg: spacing(46),
      },
      marginLeft: {
        xs: spacing(0),
        lg: spacing(46),
      },
      marginTop: {
        xs: spacing(12),
        md: spacing(16),
      },
      gap: {
        xs: spacing(4),
        md: spacing(6),
      },
    },
  }),
);

const initialScreen = UnistylesRuntime.screen;
const initialTheme = UnistylesRuntime.getTheme();

export const IMAGE_DIMENSIONS = {
  cover: [
    { width: initialScreen.width, height: initialTheme.spacing(96) },
    { width: initialScreen.width, height: initialTheme.spacing(200) },
  ],
  poster: [
    {
      width: initialTheme.spacing(28) * (3 / 4),
      height: initialTheme.spacing(28),
    }, // for 3:4
    {
      width: initialTheme.spacing(48) * (3 / 4),
      height: initialTheme.spacing(48),
    }, // for 3:4
  ],
};

export default stylesheet;
